import type { EditorAdapter } from '../components/Editor/core/types';

export const useEditorOperations = (adapter: EditorAdapter) => {
    const insertImage = (imageUrl: string, alt = 'Image') => {
        adapter.insertMarkdown(`\n\n![${alt}](${imageUrl})`);
    };

    const getContent = () => {
        return adapter.getMarkdown();
    };

    return {
        insertImage,
        getContent
    };
};
